import React, { useContext } from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { Link45deg, Share } from "react-bootstrap-icons"
import { toast } from "react-toastify"
import styles from "./styles.module.scss"
import "react-toastify/dist/ReactToastify.css"
import clsx from "clsx"
import { CHER_LINK_IMAGE_URL } from "../../util/constants"
import { UserContext } from "../HomeApp"

interface ShareUrlButtonProps {
  nadaUrl: string
  renderMode?: "icon" | "text" | "button"
  color?: "blue" | "white"
  className?: string
  alignment?: string
  iconSize?: number
}

export const ShareUrlButton: React.FC<ShareUrlButtonProps> = ({
  nadaUrl,
  renderMode = "icon",
  color = "blue",
  className = "",
  alignment = "align-top",
  iconSize = 22,
}) => {
  const { user } = useContext(UserContext)
  const bgColor = color === "blue" ? "bg-blue-600" : "bg-white"
  const textColor = color === "blue" ? "text-blue-600" : "text-white"
  const marginClass = /m(l|r|t|b)-\d+/.test(className) ? className : "ml-2 mb-2"

  const shareUrl = user
    ? `${nadaUrl}${nadaUrl.includes("?") ? "&" : "?"}ref=${user.id}&utm_source=share`
    : nadaUrl

  const Msg = () => (
    <div className="flex">
      <img
        src={CHER_LINK_IMAGE_URL}
        alt="share-icon"
        style={{ width: "50px" }}
        className="mr-2"
      />
      <div>
        <span className="font-bold">Cher Link</span>
        <br />
        copied to your clipboard!
      </div>
    </div>
  )
  // react-copy-to-clipboard's own onClick prop is discarded internally (its
  // render() clones the child and overwrites onClick with its own handler),
  // but it does forward to the child element's onClick after copying — so
  // stopPropagation has to live on the inner <button>, not on CopyToClipboard.
  const stopBubbling = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <>
      <CopyToClipboard
        text={shareUrl}
        onCopy={() =>
          toast.success(<Msg />, {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            icon: false,
          })
        }
      >
        {renderMode === "icon" ? (
          <button
            className={`${alignment} focus:outline-none`}
            type="button"
            onClick={stopBubbling}
            aria-label="Share"
            title="Share"
          >
            <Link45deg className={`${textColor} ml-1`} size={iconSize} />
          </button>
        ) : renderMode === "text" ? (
          <button
            type="button"
            className={clsx("focus:outline-none", textColor, className)}
            onClick={stopBubbling}
          >
            Cher
          </button>
        ) : (
          <button
            type="button"
            className={clsx(
              bgColor,
              styles.cherBtn,
              "focus:outline-none px-1 rounded text-sm text-white",
              marginClass,
            )}
            onClick={stopBubbling}
          >
            <Share
              size={11}
              className="text-white inline align-baseline mr-1"
            />
            Cher
          </button>
        )}
      </CopyToClipboard>
    </>
  )
}
